import { Link } from 'react-router-dom';


export default function Terms() {
  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between">
          <Link to="/" className="text-xl font-bold bg-gradient-to-r from-amber-600 to-orange-500 bg-clip-text text-transparent">
            RecoverRefunds
          </Link>
          <Link to="/signup" className="text-sm text-amber-600 hover:text-amber-700 font-medium">
            Sign Up
          </Link>
        </div>
      </header>

      <div className="max-w-4xl mx-auto px-4 py-12">

        <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
          <h1 className="text-3xl font-bold text-slate-900 mb-2">Terms of Service</h1>
          <p className="text-slate-500 mb-8">Last updated: January 2, 2026</p>

          <div className="prose prose-slate max-w-none">
            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">1. Acceptance of Terms</h2>
            <p className="text-slate-600 mb-4">
              By accessing or using RecoverRefunds ("Service"), you agree to be bound by these Terms of Service.
              If you do not agree to these terms, do not use the Service.
            </p>

            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">2. Description of Service</h2>
            <p className="text-slate-600 mb-4">
              RecoverRefunds provides AI-powered fraud detection and dispute management services for restaurants
              and food service businesses using third-party delivery platforms. Our services include:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-4 space-y-2">
              <li>Automated analysis of refund requests to identify potential fraud</li>
              <li>Generation of dispute letters and supporting documentation</li>
              <li>Tracking and analytics for dispute outcomes</li>
              <li>Integration with delivery platform dashboards</li>
            </ul>

            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">3. User Responsibilities</h2>
            <p className="text-slate-600 mb-4">
              You agree to:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-4 space-y-2">
              <li>Provide accurate account and business information</li>
              <li>Maintain the security of your account credentials</li>
              <li>Use the Service only for lawful purposes</li>
              <li>Not misrepresent information in disputes</li>
              <li>Comply with all applicable delivery platform terms of service</li>
            </ul>

            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">4. Platform Credentials</h2>
            <p className="text-slate-600 mb-4">
              By providing credentials for third-party delivery platforms, you authorize RecoverRefunds to:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-4 space-y-2">
              <li>Access your order and refund data</li>
              <li>Submit disputes on your behalf</li>
              <li>Monitor dispute status and outcomes</li>
            </ul>
            <p className="text-slate-600 mb-4">
              You acknowledge that some delivery platforms may have terms restricting third-party access.
              You are responsible for ensuring compliance with those terms.
            </p>

            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">5. Fees and Payment</h2>
            <p className="text-slate-600 mb-4">
              During the beta period, the Service is provided free of charge. Future pricing will be
              communicated before any charges apply. You will have the opportunity to review and accept
              pricing terms before being charged.
            </p>

            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">6. Disclaimer of Warranties</h2>
            <p className="text-slate-600 mb-4">
              THE SERVICE IS PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND. We do not guarantee:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-4 space-y-2">
              <li>That disputes will be resolved in your favor</li>
              <li>Specific recovery amounts or rates</li>
              <li>Uninterrupted or error-free service</li>
            </ul>

            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">7. Limitation of Liability</h2>
            <p className="text-slate-600 mb-4">
              RecoverRefunds shall not be liable for any indirect, incidental, special, or consequential
              damages arising from your use of the Service. Our total liability shall not exceed the
              amount you paid for the Service in the 12 months preceding the claim.
            </p>

            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">8. Termination</h2>
            <p className="text-slate-600 mb-4">
              Either party may terminate this agreement at any time. Upon termination:
            </p>
            <ul className="list-disc pl-6 text-slate-600 mb-4 space-y-2">
              <li>Your access to the Service will be revoked</li>
              <li>You may request export of your data within 30 days</li>
              <li>We will delete your data within 90 days unless legally required to retain it</li>
            </ul>

            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">9. Changes to Terms</h2>
            <p className="text-slate-600 mb-4">
              We may update these terms from time to time. We will notify you of material changes via
              email or through the Service. Continued use after changes constitutes acceptance.
            </p>

            <h2 className="text-xl font-semibold text-slate-900 mt-8 mb-4">10. Contact</h2>
            <p className="text-slate-600 mb-4">
              For questions about these terms, contact us at:
              <br />
              <a href="mailto:legal@recoverrefunds.com" className="text-amber-600 hover:text-amber-700">
                legal@recoverrefunds.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
